// src/utils/gameWords.ts
import { isEqual } from 'lodash';

// Słowo w grze to kopia słowa z listy. Kopia dokładana do powtórki (albo jako przerywnik przed nią) ma w grze własny
// id, po którym gra odróżnia ją od pierwszego wystąpienia — id słowa na liście niesie wtedy w polu listWordId
type GameWord = { id: string, listWordId?: string };

// Id słowa na liście: pod nim „Edytuj zwrot” zapisuje poprawkę i po nim poprawka trafia do wszystkich kopii w grze
export const getListWordId = (word: GameWord): string => word.listWordId ?? word.id;

// Skład listy — zmienia się, gdy słowa dochodzą albo znikają, a nie przy poprawce tekstu ani innej kolejności
export const getListComposition = (words: GameWord[]): string => words.map(({ id }) => id).sort().join();

// Słowa w grze z tekstem z listy, w tej samej kolejności i z kopiami. Bez różnic zwraca te same słowa, żeby gra
// nie przeliczała się na nowo
export const withListTexts = <T extends GameWord>(gameWords: T[], listWords: T[]): T[] => {
  const updated = gameWords.map((word) => {
    const listWord = listWords.find(({ id }) => id === getListWordId(word));

    return listWord ? { ...word, ...listWord, id: word.id } : word;
  });

  return isEqual(updated, gameWords) ? gameWords : updated;
};
